import React from 'react';
import './Logo.scss';
import BlankWidget from '../../components/CategoryListing/Widgets/BlankWidgets';
const MainHeaderLogo = props => {
    const { appLogo, dataLocale: { LENSKART } } = props;
    return (
        <React.Fragment>
            {
                appLogo ?
                    <div className="logo">
                        <a href="//www.lenskart.com/">
                            <img src={appLogo} alt={LENSKART} title={LENSKART} />
                        </a>
                    </div > :
                    <div className="blank-logo">
                        <BlankWidget styleObj="" rowsArray={['1']} />
                    </div>
            }
        </React.Fragment>

    );
};

export default MainHeaderLogo;
